import React from 'react'
import { Button, Flex, H2, Input, Span, SelectDropdown, Line } from '../../lib/components'
import { Pagination } from '../../lib/components/Pagination'
import { useBreakpoint } from '../../lib/utils/hooks'
import { SM } from '../../lib/utils/constants'
import { GetNewsletterSubscribersSearchParams } from '../../lib/types'
import { newsletterSubscriberSort } from '../../lib/utils/message'
import { getFormattedDate } from '../../lib/utils/helpers'
import './newsletter-subscribers-list.scss'

type NewsletterSubscribersListPresenterProps = {
  subscribers: any[]
  isLoading: boolean
  searchParams: GetNewsletterSubscribersSearchParams
  handleSearchParams: (params: { name: string; value: string }) => void
  resetSearchParams: () => void
  pagination: {
    total: number
    limit: number
    count: number
    offset: number
  }
  handleCurrentPage: (currentPage: number) => void
  currentPage: number
}

const formattedDate = (date: string) => getFormattedDate(new Date(date), 'D MMM YYYY [at] h:mm A')

function NewsletterSubscribersListPresenter({
  subscribers,
  isLoading,
  searchParams,
  handleSearchParams,
  resetSearchParams,
  pagination,
  handleCurrentPage,
  currentPage,
}: NewsletterSubscribersListPresenterProps) {
  const { breakpoint } = useBreakpoint()

  return (
    <Flex variant='column-center'>
      <H2 classes={['mb-48']} text='Newsletter Subscribers' />

      <div className='subscribers-list-toolbar-layout gap-12 mb-16 mt-16'>
        <Input
          name='keyword'
          value={searchParams.keyword || ''}
          maxLength={100}
          handleChange={(e) => handleSearchParams({ name: e.target.name, value: e.target.value })}
          placeholder='Search by email or name'
        />
        <div className='sort-reset'>
          <SelectDropdown
            name='sortBy'
            id='sortById'
            formId=''
            list={newsletterSubscriberSort}
            placeholder={'Sort'}
            value={searchParams.sortBy}
            handleChange={(val) => handleSearchParams({ name: 'sortBy', value: val })}
            dataTestId='subscribers-list-sort-select'
          />
          <Button
            handleClick={() => resetSearchParams()}
            classes={['reset-btn']}
            variant='secondary-btn'
            text='Reset'
          />
        </div>
      </div>

      <Line />

      {isLoading ? (
        <Flex variant={'column-center'} classes={['mt-12']}>
          <Span classes={['center']} variant={'thin'} text='Loading...' />
        </Flex>
      ) : subscribers && subscribers.length > 0 ? (
        <>
          <div className='w-100'>
            <Flex
              variant='row'
              classes={['mb-24', 'table_scroll_horizontal']}
              dataTestId='subscribers-table-container'
            >
              <table className='styled-table'>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Marketing Consent</th>
                    <th>Subscribed At</th>
                  </tr>
                </thead>
                <tbody>
                  {subscribers.map((subscriber: any) => (
                    <tr key={subscriber.id}>
                      <td>{subscriber.name || '—'}</td>
                      <td>{subscriber.email}</td>
                      <td>{subscriber.marketing_consent ? 'Yes' : 'No'}</td>
                      <td>{subscriber.created_at ? formattedDate(subscriber.created_at) : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Flex>
          </div>
          {breakpoint && breakpoint === SM ? null : (
            <Pagination
              currentPage={currentPage}
              handleCurrentPage={handleCurrentPage}
              pagination={pagination}
            />
          )}
        </>
      ) : (
        <Flex variant={'column-center'} classes={['mt-12']}>
          <Span classes={['center']} variant={'thin'} text='No Subscribers Found' />
        </Flex>
      )}
    </Flex>
  )
}

export { NewsletterSubscribersListPresenter }
